var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['zg-avatar', {
    [`zg-avatar--size-${_vm.size}`]: _vm.size,
    [`zg-avatar--background-${_vm.background}`]: _vm.background
  }]},[(_vm.image && _vm.image.src)?_c('zg-image',{attrs:{"src":_vm.image.src,"alt":_vm.image.alt,"title":_vm.image.title,"lazy-load":""}}):(_vm.product)?_c('zg-product-icon',{attrs:{"product":_vm.product}}):(_vm.text)?_c('span',[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_c('zg-icon',{attrs:{"icon":"favorite-border","color":"brand-500"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }